import { render } from "./credit-notes.vue?vue&type=template&id=bc849266"
import script from "./credit-notes.vue?vue&type=script&lang=js"
export * from "./credit-notes.vue?vue&type=script&lang=js"

import "./credit-notes.vue?vue&type=style&index=0&id=bc849266&lang=css"

import exportComponent from "/Users/newuser/Desktop/Development/Node/spider-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__